import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Zap } from 'lucide-react';

const MobileBottomBar = ({ onCTAClick, spotsLeft }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show bar after scrolling past the hero section
      setIsVisible(window.scrollY > 600);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!isVisible) return null;

  return (
    <motion.div
      initial={{ y: 100 }}
      animate={{ y: 0 }}
      exit={{ y: 100 }}
      className="fixed bottom-0 left-0 right-0 z-40 md:hidden glass border-t border-[#2E5C41]/10"
      data-testid="mobile-bottom-bar"
    >
      <div className="px-4 py-3">
        <div className="flex items-center justify-between gap-3">
          <div>
            <p className="text-sm font-medium text-[#1A2E24]">Acceso Fundadores</p>
            <p className="text-xs text-[#D95A39]">Solo {spotsLeft} cupos</p>
          </div>
          <motion.button
            onClick={onCTAClick}
            className="flex items-center gap-2 px-5 py-2.5 bg-[#2E5C41] text-white text-sm font-bold rounded-full"
            whileTap={{ scale: 0.95 }}
            data-testid="cta-mobile-bottom"
          >
            <Zap className="w-4 h-4" strokeWidth={1.5} />
            $29/mes
          </motion.button>
        </div>
      </div>
    </motion.div>
  );
};

export default MobileBottomBar;
